module.exports = __webpack_public_path__ + "static/fonts/Fact-ThinItalic.243007b.ttf";